import { render, staticRenderFns } from "./CalendarsConfig.vue?vue&type=template&id=9ada72ae&scoped=true&"
import script from "./CalendarsConfig.vue?vue&type=script&lang=js&"
export * from "./CalendarsConfig.vue?vue&type=script&lang=js&"
import style0 from "./CalendarsConfig.vue?vue&type=style&index=0&id=9ada72ae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ada72ae",
  null
  
)

export default component.exports